import { SectionShell, Panel, Note } from "@/components/dash/primitives";
import { ChartTip, CHART } from "@/components/dash/chartkit";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList,
} from "recharts";

export default function Thailand({ data, num, title }) {
  return (
    <SectionShell id="thailand" num={num} title={title}>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
        {data.blocks.map((b, i) => (
          <div key={i} className="bg-white border border-slate-200 rounded-xl p-6">
            <h3 className="font-display text-lg font-semibold text-slate-900">{b.title}</h3>
            <p className="text-sm text-slate-600 mt-3 leading-relaxed">{b.text}</p>
          </div>
        ))}
      </div>

      <Panel
        title={data.orderbook_title}
        subtitle="Vessels ordered by size cluster (Q3 2025 – Q2 2026)"
        source="Source: Alphaliner Newsletter 2026-25"
        testid="chart-orderbook"
        csv={{ name: "Small-ship orderbook", columns: ["Vessel size", "Ships ordered"], rows: data.orderbook.map((d) => [d.size, d.count]) }}
      >
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={data.orderbook} margin={{ top: 16, right: 8, left: 8, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="#f1f5f9" />
            <XAxis dataKey="size" tickLine={false} axisLine={false} tick={{ fill: "#64748b", fontSize: 11 }} />
            <YAxis tickLine={false} axisLine={false} tick={{ fill: "#64748b" }} width={36} />
            <Tooltip cursor={{ fill: "#f8fafc" }} content={<ChartTip formatter={(v) => `${v} vessels`} />} />
            <Bar dataKey="count" name="Ships ordered" fill={CHART.orange} radius={[4, 4, 0, 0]} maxBarSize={80}>
              <LabelList dataKey="count" position="top" className="font-num" fill="#334155" fontSize={12} />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Panel>

      <Note>{data.orderbook_note}</Note>
      <Note accent>{data.precision}</Note>
    </SectionShell>
  );
}
